// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f105432c","453":"fd6d1e98","622":"7e8aefc7","977":"526f3b6b"}[chunkId] + ".chunk.js";
};